(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-item').forEach(item => {
    const icon = item.querySelector('.faq-item__icon');

    item.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');

      icon.src = isOpen
        ? 'https://cdn.shopify.com/s/files/1/0628/6350/7680/files/dropdown_collapse.svg?v=1765812681'
        : 'https://cdn.shopify.com/s/files/1/0628/6350/7680/files/dropdown_expand.svg?v=1765812682';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-trust-icons"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".trust-icons-track");
  const items = Array.from(document.querySelectorAll(".trust-icon-item"));
  const prevBtn = document.querySelector(".trust-prev");
  const nextBtn = document.querySelector(".trust-next");
  const pagination = document.querySelector(".trust-icons-pagination");
  const carousel = document.querySelector(".trust-icons-carousel");

  if (!track || items.length === 0) return;

  let currentPage = 0;
  let itemsPerPage = getItemsPerPage();
  let totalPages = Math.ceil(items.length / itemsPerPage);
  let autoplayInterval;

  function getItemsPerPage() {
    return window.innerWidth < 768 ? 1 : 2;
  }

  function updateLayout() {
    itemsPerPage = getItemsPerPage();
    totalPages = Math.ceil(items.length / itemsPerPage);

    const itemWidth = carousel.offsetWidth / itemsPerPage;
    items.forEach(item => {
      item.style.flex = `0 0 ${itemWidth}px`;
    });

    updateSlider();
  }

  function updateSlider() {
    const itemWidth = carousel.offsetWidth / itemsPerPage;
    const offset = currentPage * itemWidth * itemsPerPage;
    track.style.transform = `translateX(-${offset}px)`;

    pagination.textContent = `${currentPage + 1}/${totalPages}`;
    prevBtn.disabled = currentPage === 0;
    nextBtn.disabled = currentPage >= totalPages - 1;
  }

  function goToNextSlide() {
    currentPage = (currentPage + 1) % totalPages;
    updateSlider();
  }

  function goToPreviousSlide() {
    if (currentPage > 0) {
      currentPage--;
      updateSlider();
    }
  }

  prevBtn.addEventListener("click", () => {
    goToPreviousSlide();
    resetAutoplay();
  });

  nextBtn.addEventListener("click", () => {
    goToNextSlide();
    resetAutoplay();
  });

  function startAutoplay() {
    autoplayInterval = setInterval(goToNextSlide, 5000);
  }

  function resetAutoplay() {
    clearInterval(autoplayInterval);
    startAutoplay();
  }

  window.addEventListener("resize", () => {
    currentPage = 0;
    updateLayout();
  });

  updateLayout();
  startAutoplay();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
